module.exports = __webpack_public_path__ + "img/analysisBgImg2.a5a57d7b.png";